import React, { useState } from "react";
import PPEConsole from "./SimulationPPEConsole";
interface CapacityOffer {
  start_date: string;
  end_date: string;
  source_type: string;
  id: number;
  source_id: number;
  plant_capacity: string;
  plf: string;
  variable_charge: string;
  fixed_charge: string;
  status?: boolean;
  offerType: "capacity";
}

interface BatteryOffer {
  start_date: string;
  end_date: string;
  id: number;
  battery_id: number;
  battery_capacity_in_mwh: number;
  chargingRate: string;
  vc: string;
  fc: string;
  status?: boolean;
  offerType: "battery";
}

type CombinedOffer = CapacityOffer | BatteryOffer;

interface PPEFormData {
  startDate: string;
  endDate: string;
  scenario: string;
  offers: CombinedOffer[];
}

interface PPEConsoleTableProps {
  open: boolean;
  setOpen: any;
  setError?: any;
  refreshKey: any;
  setRefreshKey: any;
  onActiveScenarioChange?: (scenario: number) => void;
}

export default function PPEConsoleTable({
  open,
  setOpen,
  setError,
  refreshKey,
  setRefreshKey,
  onActiveScenarioChange,
}: PPEConsoleTableProps) {
  const [loading, setLoading] = useState(false);

  const handleApply = async (ppeData: PPEFormData) => {
    setLoading(true);
    try {
      // Uncomment and implement when API is ready
      // const payload = {
      //   mcpScenario: ppeData.scenario,
      //   offers: ppeData.offers.map((offer) => ({
      //     id: offer.id,
      //     type: offer.offerType === "capacity" ? offer.type : "Battery",
      //     status: offer.status ? true : false,
      //     offerType: offer.offerType,
      //   })),
      // };
      // const res = await UpdateTraderOffersToggleData(payload);
      // if (res) {
      //   setRefreshKey((prev: number) => prev + 1);
      //   setOpen(!open);
      // }

      // Temporary: Just close the panel and refresh
      setRefreshKey((prev: number) => prev + 1);
      setOpen(!open);
    } catch (error) {
      console.error("Error submitting data", error);
      if (setError) setError("Error submitting data");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    // Reset logic if needed
  };

  return (
    <div
      className="gas-chart-container simulation_table shadow-[rgba(149,157,165,0.2)_0px_8px_24px] bg-[#F8F9FA] !p-0 overflow-hidden"
      id="slide"
      style={{
        width: "21%",
        position: "relative",
        zIndex: "2",
        height: "calc(-195px + 100vh)",
        transition: "all 0.3s ease-out",
      }}
    >
      <PPEConsole
        loading={loading}
        onApply={handleApply}
        onReset={handleReset}
        refreshKey={refreshKey}
        isSliderOpen={!open}
        setRefreshKey={setRefreshKey}
        onActiveScenarioChange={onActiveScenarioChange}
      />
    </div>
  );
}
